import { TextButton } from '@carboncopyco/ui';
import { useEffect, useState } from 'react';
import { UserEventsEnum } from '../../../shared/enums/UserEventsEnum';

export const ActiveUrlDetails = () => {
  const [pageTitle, setPageTitle] = useState<string>('');
  useEffect(() => {
    window?.dsDesktop?.ipcRenderer.on(
      UserEventsEnum.UPDATE_PAGE_TITLE,
      (message: any) => {
        if (message?.pageTitle) {
          setPageTitle(message.pageTitle);
        }
      }
    );
  }, []);

  return (
    <div className="flex flex-col justify-center ellipsis-240">
      <div>
        <TextButton
          ellipsis
          label={pageTitle}
          color="text-ds-natural-600"
        />
      </div>
    </div>
  );
};
